/**
 * Copyright © 2018 Emu Analytics
 */

import { Client } from './client';
import { BaseEndpoints } from './base.endpoints';
import { ITileSource } from './api-interfaces';

export class TileSourceEndpoints extends BaseEndpoints<ITileSource> {
  constructor(client: Client) {
    super(client, 'tilesources');
  }

  drivers(): Promise<string[]> {
    return this.client._get(`/api/v1/tilesources/drivers`).catch(e => {
      if (e.statusCode === 404) {
        // Backwards compatibility for pre-1.0.0 Flo.w
        return ['tilelive', 'dataset'];
      }
    });
  }
}
